import { Button, Flex, Icon, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { useEmberRouter } from '../../../../../../contexts/emberRouterContext'
import { EmberRoute } from '../../../../../../enums/emberRoute'
import * as Styled from './styles'

export const SiretPendingAssignmentTopBar = (): ReactElement | null => {
  const { t } = useTranslation()
  const { navigate } = useEmberRouter()

  const handleAddSiretClick = useCallback(() => {
    navigate(EmberRoute.SettingsOrganization)
  }, [navigate])

  return (
    <Styled.SiretPendingAssignmentTopBar>
      <Flex alignItems="center" gap={Spacing.S16}>
        <Icon icon="info" color="currentColor" size="md" />
        <Text>{t('siret_pending_assignment_top_bar.message')}</Text>
      </Flex>
      <Button iconRight="arrowRight" onClick={handleAddSiretClick} variant="tonal">
        {t('siret_pending_assignment_top_bar.button.add_siret')}
      </Button>
    </Styled.SiretPendingAssignmentTopBar>
  )
}
